import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from '@phosphor-icons/react';
import { PageWrapper } from '../styles/shared';

const NotFoundContainer = styled.main`
  background: #0e1217;
  color: white;
  min-height: 100vh;
  width: 100%;
  padding-top: 64px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

const Content = styled.div`
  max-width: 600px;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Title = styled.h1`
  font-size: 6rem;
  color: #28c0ef;
  margin-bottom: 1rem;
  font-weight: 800;
`;

const Subtitle = styled.h2`
  font-size: 2rem;
  color: white;
  margin-bottom: 2rem;
`;

const Description = styled.p`
  color: rgba(255, 255, 255, 0.8);
  font-size: 1.2rem;
  margin-bottom: 3rem;
  line-height: 1.6;
  text-align: center;
`;

const BackButton = styled.button`
  background: rgba(40, 192, 239, 0.1);
  border: 1px solid rgba(40, 192, 239, 0.2);
  color: #28c0ef;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.1rem;
  cursor: pointer;
  padding: 1rem 2rem;
  border-radius: 12px;
  transition: all 0.2s;

  &:hover {
    background: rgba(40, 192, 239, 0.2);
    transform: translateY(-2px);
  }
`;

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <PageWrapper>
      <NotFoundContainer>
        <Content>
          <Title>404</Title>
          <Subtitle>Page Not Found</Subtitle>
          <Description>
            Oops! The page you're looking for doesn't exist or has been moved.
            Let's get you back on track.
          </Description>
          <BackButton onClick={() => navigate('/')}>
            <ArrowLeft size={24} weight="bold" />
            Back to Home
          </BackButton>
        </Content>
      </NotFoundContainer>
    </PageWrapper>
  );
};

export default NotFoundPage;